<template>
  <div>
    <template v-if="codehas.isValid">
      <nprogress-container></nprogress-container>
      <div class="hide-in-print-screen">
        <notifications class="max-w-md select-none" position="bottom right" width="100%">
          <template slot="body" slot-scope="props">
            <div class="inset-0 flex items-end justify-center pointer-events-none sm:items-start sm:justify-end">
              <div class="w-full mx-4 mb-4 bg-white rounded-lg pointer-events-auto">
                <div class="rounded-lg shadow-md border border-blue-200 overflow-hidden">
                  <div @click="props.close" class="p-4">
                    <div class="flex items-start">
                      <div class="flex-shrink-0">
                        <svg-vue class="h-6 w-6 text-red-400" icon="font-awesome.times-circle-light" v-if="props.item.type === 'error'"></svg-vue>
                        <svg-vue class="h-6 w-6 text-orange-400" icon="font-awesome.exclamation-triangle-light" v-else-if="props.item.type === 'warning'"></svg-vue>
                        <svg-vue class="h-6 w-6 text-blue-400" icon="font-awesome.info-circle-light" v-else-if="props.item.type === 'info'"></svg-vue>
                        <svg-vue class="h-6 w-6 text-green-400" icon="font-awesome.check-circle-light" v-else></svg-vue>
                      </div>
                      <div class="ml-3 w-0 flex-1 pt-0.5">
                        <p class="text-sm leading-5 font-medium text-gray-900">
                          {{ props.item.title }}
                        </p>
                        <p class="py-1 text-sm leading-5 text-gray-900" v-html="props.item.text"></p>
                      </div>
                      <div class="ml-4 flex-shrink-0 flex">
                        <button
                          @click="props.close"
                          class="inline-flex text-gray-400 focus:outline-none focus:text-gray-900 transition ease-in-out duration-150"
                          type="button"
                        >
                          <svg-vue class="h-5 w-5 p-px text-red-400" icon="font-awesome.times-circle-solid"></svg-vue>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </notifications>
      </div>
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="min-h-screen bg-white p-6 flex flex-col justify-center mx-auto sm:py-12">
        <div class="h-auto pb-20 p-5 w-full md:w-2/3 bg-blue-600 flex flex-col space-y-5 mx-auto rounded-xl shadow-lg hover:rotate-2 transition-transform">
          <div class="justify-center mb-2 md:flex items-center">
            <img :src="$store.state.settings.icon" :alt="$store.state.settings.app_name" class="w-20 h-20" />
          </div>
          <h1 class="font-medium text-white text-2xl tracking-wide">
            Welcome To <strong>{{ $store.state.settings.name | capitalize }}</strong>
          </h1>
          <h4 class="font-normal tracking-wide text-xl text-white">Please register and verify your purchased license to use the {{ $store.state.settings.name }}</h4>
          <a href="https://codehas.gitbook.io/app/license-registration" class="btn bg-yellow-300 text-xl text-center" target="_blank">Click here to read simple steps</a>
          <span class="px-2 text-xs text-white">Status : {{ codehas.feedback }}</span>
          <h2 class="font-normal tracking-wide text-2xl text-white lg:w-2/3">
            Thank you for purchasing repair box
            <small> <br />Version : {{ $store.state.settings.version }} </small>
          </h2>
          <div class="flex flex-col">
            <div class="font-normal text-white text-sm tracking-wider">Rose Finch</div>
            <div class="font-normal text-white text-sm tracking-wider">info.codehas@gmail.com</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer';

export default {
  name: 'App',
  components: {
    NprogressContainer,
  },
  data() {
    return {
      showDemo: true,
      codehas: {
        ekey: 'kUSiAbZmt5r8K3W@codehas.com@tBGWja8ieWnmMVv8UAlE2PGKgqyN4',
        current: null,
        license: null,
        isValid: false,
        feedback: 'Unverified',
        loading: false,
      },
      caps: null,
    };
  },
  mounted() {
    if (route('system.config')) {
      this.codehas.current = '@' + window.location.host;
      if (this.pack) {
        this.codehas.patch_hash = this.pack;
        this.verification();
      }
    }
  },
  computed: {
    serialString() {
      return this.codehas.ekey + this.domain;
    },
    pack() {
      return window.app.application_pack;
    },
    domain() {
      let url = window.location.host;
      var parts = url.replace(/^(www\.)/, '').split('.');
      var address = parts.join('.');
      return address.replace(/(^\.*)|(\.*$)/g, '');
    },
  },
  methods: {
    verification() {
      this.codehas.loading = true;
      const decryptedText = this.CryptoJS.AES.decrypt(this.codehas.patch_hash.replaceAll('-', '+'), this.serialString).toString(this.CryptoJS.enc.Utf8);
      if (decryptedText === this.codehas.current) {
        this.codehas.feedback = 'Awesome, it has been validated successfully ! ';
        this.codehas.isValid = true;
        this.codehas.loading = false;
      } else {
        this.codehas.feedback = 'Invalid license !';
        this.codehas.loading = false;
      }
    },
  },
};
</script>
